import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '~/components/core';
import { formatNumber } from '~/lib/format';
import { useAppSelector, useStyles } from '~/hooks';
import { useSubscribeQuote } from '~/hooks/useSubscribeQuote';
import { symbolsSelector } from '~/state/selectors';
import { FONT_SIZE_M } from '~/constants/typography';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

type Props = {
    symbol: string;
    side: 'buy' | 'sell';
};

// The price the trade-setup distances are measured from. Side-aware like the order ticket: a buy
// is entered at the ask, a sell at the bid. Subscribes while mounted — the symbols map otherwise
// holds only the snapshot from the initial load.
export default function MarketPriceRow({ symbol, side }: Props) {
    const styles = useStyles(stylesGenerator);
    useSubscribeQuote(symbol);
    const dataSymbol = useAppSelector((state) => symbolsSelector(state)[symbol]);

    if (!dataSymbol) {
        return null;
    }

    const price = side === 'buy' ? dataSymbol.price.ask : dataSymbol.price.bid;

    return (
        <View style={styles.row}>
            <Text style={styles.label}>ai-strategy-current-price</Text>
            <Text noTranslate fontType="LATO_BOLD" style={styles.value}>
                {formatNumber(price, dataSymbol.digits)}
            </Text>
        </View>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        row: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: scaleSize(8),
            backgroundColor: theme.backgroundSecondary,
            paddingHorizontal: scaleSize(10),
            paddingVertical: scaleSize(8),
            marginTop: scaleSize(4),
        },
        label: {
            fontSize: FONT_SIZE_M,
            color: theme.textSecondary,
        },
        value: {
            fontSize: FONT_SIZE_M,
            color: theme.text,
        },
    });
